import { CallMissedOutlined, CheckOutlined } from "@vindr/icons";
import { Button, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../../contexts/GlobalContext";
import { PERMISSIONS } from "@vindr/services/constants/permissions.constant";

const CurrentPatient = ({
  isPopup,
  dataSource,
  config,
  onDone,
  onMissCall,
}: {
  isPopup: boolean;
  dataSource: any[];
  config: any;
  onDone: () => void;
  onMissCall: () => void;
}) => {
  const { t } = useTranslation('Vindoc');
  const { keycloak } = useGlobalState();
  const patient = dataSource?.[0];
  const showPatientName =
    isPopup ? config?.in_process_popup_patient_name !== 3 : config?.in_process_window_patient_name !== 3;
  const showPatientId = isPopup ? config?.in_process_popup_patient_id !== 3 : config?.in_process_window_patient_id !== 3;
  const showSlicePatientId = isPopup ? config?.in_process_popup_patient_id === 2 : config?.in_process_window_patient_id === 2;

  return (
    <div
      className="mb-2 flex items-center rounded-lg bg-blue-700 py-2"
      style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)' }}
    >
      <div className="status flex flex-col items-center justify-center px-6 uppercase text-white">
        <div className="font-bold text-white">{t('QMS.In Progress')}</div>
        <div className="font-bold text-white">({dataSource?.length || 0}NB)</div>
      </div>
      <div className="flex-1 rounded-lg bg-white p-2 text-4xl flex justify-between items-center">
        <span className="flex items-center font-bold text-blue-700 h-7">{showPatientName && patient?.patient_name} - {showPatientId && (showSlicePatientId ? patient?.patient_id.slice(-4) : patient?.patient_id)}</span>
        {(isPopup && dataSource?.length > 0 && keycloak.hasOneOfPerm([PERMISSIONS.qms.update])) ? <span className="flex items-center">
          <Tooltip title={t("QMS.Done")}>
            <Button type="text" className="w-12 rounded-lg">
              <CheckOutlined className="text-2xl text-green-500" onClick={onDone} />
            </Button>
          </Tooltip>
          <Tooltip title={t("QMS.Miss Call")}>
            <Button type="text" className="w-12 rounded-lg">
              <CallMissedOutlined className="text-2xl text-red-500" onClick={onMissCall} />
            </Button>
          </Tooltip>
        </span> : null}
      </div>
      <div className="piority px-6 text-xl font-bold text-white uppercase">{patient?.priority === 4 ? t('QMS.Urgent') : patient?.priority === 3 ? t('QMS.High') : t('QMS.Normal')}</div>
    </div>
  );
};

export default CurrentPatient;
